import React, {useEffect, useRef, useState} from "react";
/** @jsx jsx */
import {css,jsx} from "@emotion/react";
import {hot} from "react-hot-loader";
import styled from "@emotion/styled";
import {curTheme} from "../../js-app/theme";
import {RecoilRoot} from "recoil";
import {render} from "react-dom";
import {useConnectedState, useConnectedValue, useExternalAtom} from "../../js/state-hooks";
import {as_memoPopupMessage, as_memory, MemoItem} from "../../js/app";
import {as_memoSettings} from "../../js-backend/state";

const s = 50;
const MemoFloatingButtonDiv = styled.div({
	backgroundColor:curTheme.memoBtnColor,
	width:s,
	height:s,
	cursor:'pointer',
	overflow:'hidden',
	borderRadius:s/2,
	transition:'all 0.3s',
	'&.showing':{
		transform:'none !important',
	},
	'&.hover':{
		width:300,
		'.title':{
			opacity:1
		}
	},
	svg:{
		position:'absolute',
		left:13,
		top:'50%',
		transform:'translateY(-50%)',
		width:22,
		height:22,
		g:{
			fill:'var(--mmb-text-on-highlight-col)'
		}
	},
	position:'fixed'
});
const MemoTitle = styled.div({
	pointerEvents:'none',
	transition:'all 0.3s',
	opacity:0,
	paddingLeft:50,
	paddingTop:16,
	fontWeight:'bold',
	paddingRight:20,
	display:"inline-block",
	fontSize:18,
	lineHeight:1,
	// backgroundColor:curTheme.memoBtnColor,
	color:'var(--mmb-text-on-highlight-col)',
});
const NumDisplay = styled.div({
	border:'2px solid ' + curTheme.memoBtnColor,
	zIndex:2,
	backgroundColor:'var(--mmb-text-on-highlight-col)',
	fontSize:9,
	fontWeight:'bold',
	position:'absolute',
	left:23,
	top:7,
	width:20,
	borderRadius:'50%',
	height:20,
	span:{
		position:'absolute',
		left:'50%',
		top:'50%',
		transform:'translate(-50%,-50%)',
		lineHeight:1,
	}
	
});
interface IMemoFloatingButtonProps{

}
const MemoFloatingButton:React.FC<IMemoFloatingButtonProps> = hot(module)(() => {
	const memoData = useConnectedValue(as_memoSettings);
	const [asMemo,setAsMemo] = useExternalAtom<MemoItem[]>(as_memory);
	const [asMessage,setAsMessage] = useExternalAtom<string>(as_memoPopupMessage);
	
	useEffect(()=>{
		if(!asMessage){
			setHover(false);
		}else{
			setHover(true);
			setTimeout(()=>{
				setHover(false);
			},1000);
			setTimeout(()=>{
				as_memoPopupMessage.set('');
			},1500);
		}
	},[asMessage]);
	const [hover,setHover] = useState(false);
	const self = useRef(null);
	
	
	return (
		<MemoFloatingButtonDiv onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)} className={'memo-floating-button ' + (hover ? 'hover' : '') + (asMemo.length > 0 ? ' showing' : '')} style={{maxWidth:self?.current?.clientWidth, ...memoData.css, ...memoData.anim}}>
			<NumDisplay><span>{asMemo.length}</span></NumDisplay>
			<svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<g id="btn-star-icon" fill="#FFD900">
					<polygon id="Star-Copy" points="6.5 9.88136691 2.48277907 12.3292178 3.64 7.86458638 -1.22905158e-13 4.91280998 4.73242279 4.60136691 6.5 0.329217845 8.26757721 4.60136691 13 4.91280998 9.36 7.86458638 10.5172209 12.3292178"></polygon>
				</g>
			</svg>
			<MemoTitle className={'title'} ref={self}>{asMessage ? asMessage : 'Merkzettel'}</MemoTitle>
		</MemoFloatingButtonDiv>
	);
});
export default MemoFloatingButton;

if(!document.getElementById('neo-memo-btn')){
    var element = document.createElement("div");
    element.classList.add('__neobooking')
    element.id = 'neo-memo-btn';
    document.querySelector("body").appendChild(element);
}
render(<RecoilRoot><MemoFloatingButton/></RecoilRoot>, document.getElementById('neo-memo-btn'));